import React from 'react';
import { Col, Grid, Layout, Row, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { ArrowLeftOutlined } from '@ant-design/icons';
import InitialSegmentationForm, { SegmentationFormValues } from './InitialSegmentationForm';
import MerchantDetailsForm from './MerchantDetailsForm';
import Button from '../../components/Button/Button';
import ExpressLogo from '../../assets/img/expressLogo.svg?react';
import { colorBorder } from '../../styles/theme';
import { useHistory } from 'react-router-dom';
import { routes } from '../../utils/routerHelper';

const { useBreakpoint } = Grid;

type SegmentationPageProps = {
  currentStep: number;
  hasMerchantUsedExpress: boolean;
};

const SegmentationPage = ({ currentStep, hasMerchantUsedExpress }: SegmentationPageProps) => {
  const { t } = useTranslation();
  const { xl: isXlBreakpoint, md: isMdBreakpoint, sm: isSmBreakpoint } = useBreakpoint();
  const browserHistory = useHistory();

  const onSubmitInitialSegmentation = ({ hasMerchantUsedExpress }: SegmentationFormValues) => {
    browserHistory.push(hasMerchantUsedExpress ? routes.existingMerchantDetails : routes.newMerchantDetails);
  };

  // arg: values: FullMerchantDetailsFormValues | LightMerchantDetailsFormValues
  const onSubmitMerchantDetails = () => {
    browserHistory.replace(routes.deliveriesDetailed);
  };
  const onBackClick = () => {
    browserHistory.goBack();
  };

  let currentForm;

  switch (currentStep) {
    case 0:
      currentForm = <InitialSegmentationForm onFinish={onSubmitInitialSegmentation} />;
      break;
    case 1:
      currentForm = (
        <MerchantDetailsForm isExistingMerchant={hasMerchantUsedExpress} onFinish={onSubmitMerchantDetails} />
      );
      break;
    default:
      currentForm = <InitialSegmentationForm onFinish={onSubmitInitialSegmentation} />;
  }

  const backButton = (
    <Button onClick={onBackClick} icon={<ArrowLeftOutlined />} type="link">
      {t('onboarding.segmentation.back')}
    </Button>
  );

  return (
    <>
      <Layout.Header style={{ height: 69, border: `1px ${colorBorder} solid` }}>
        <Row style={{ height: '100%' }}>
          <Col
            style={{
              padding: isMdBreakpoint ? '0 80px' : isSmBreakpoint ? '0 68px' : '0 32px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'start'
            }}
          >
            {currentStep > 0 && !isMdBreakpoint ? backButton : <ExpressLogo width="105.5" height="29" />}
          </Col>
        </Row>
      </Layout.Header>
      <Row
        gutter={isSmBreakpoint ? 16 : 8}
        style={{ justifyContent: 'center', padding: isMdBreakpoint ? 80 : isSmBreakpoint ? 48 : 32 }}
      >
        <Col
          xs={0}
          md={4}
          xl={8}
          style={{
            display: 'flex',
            justifyContent: isXlBreakpoint ? 'center' : 'end',
            alignItems: 'baseline'
          }}
        >
          {currentStep > 0 && isMdBreakpoint && (
            <Button onClick={onBackClick} icon={<ArrowLeftOutlined />} type="link">
              {t('onboarding.segmentation.back')}
            </Button>
          )}
        </Col>
        <Col xs={24} md={16} xl={8}>
          <Row>
            <Col span={24} style={{ textAlign: 'center' }}>
              <Typography.Title>{t('onboarding.segmentation.title')}</Typography.Title>
            </Col>
          </Row>
          <Row>
            <Col span={24} style={{ textAlign: 'center' }}>
              <Typography.Text type="secondary">{t('onboarding.segmentation.subtitle')}</Typography.Text>
            </Col>
          </Row>
          <Row style={{ marginTop: isSmBreakpoint ? 48 : 32 }}>
            <Col span={24}>{currentForm}</Col>
          </Row>
        </Col>
        <Col xs={0} md={4} xl={8} />
      </Row>
    </>
  );
};

export default SegmentationPage;
